<template>
  <div>
    <v-list>
      <v-list-item v-for="(item, index) in labelVotes" :key="index">
        <v-list-item-content>
          <p class="voting-thumb-p" :style="{'color': theme.textColor}">{{ item.label }}</p>
        </v-list-item-content>
        <v-list-item-icon @click="setThumb(index)">
          <img :src="thumb[item.vote].icon"/>
          <!-- <v-icon x-large :color="thumb[item.vote].color">{{
            thumb[item.vote].icon
          }}</v-icon> -->
        </v-list-item-icon>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
import { layoutMixin } from '@/utils/layout-mixin';
import { solutionMixin } from '@/utils/solution-mixin';

export default {
  mixins: [layoutMixin, solutionMixin],
  props: {
    spot: {},
  },
  data: () => ({
    thumb: {
      '(0)': { icon: '/img/icons/thumb_neutral.svg', color: 'grey' },
      '(1)': { icon: '/img/icons/thumb_up.svg', color: 'green' },
      '(-1)': { icon: '/img/icons/thumb_down.svg', color: 'red' },
    },
    labelVotes: [],
    disableInteraction: false,
  }),
  computed: {},
  mounted() {
    //console.log('this.spot.raetsel.lsg ====', this.spot.raetsel.lsg);
    this.spot.raetsel.lsg.forEach((label) => {
      this.labelVotes.push({ label: label, vote: '(0)' });
    });
    this.setResponses();
    this.setInput();
  },
  updated() {
    this.setInput();
  },
  methods: {
    /**
     * Check if user has already respond to this and autofill the inputs
     */
    setResponses(){
      if ( this.spot.tstatus == 3 || this.spot.tstatus == 4 ){
        this.disableInteraction = true;   
        let inputJson = this.spot.raetsel.user_input_json;
        if(typeof this.spot.raetsel.user_input_json !== 'object'){
          inputJson = JSON.parse(this.spot.raetsel.user_input_json)
        }   
        for (const [key, value] of Object.entries( inputJson )) {          
          let element = this.labelVotes.find(item=>item.label == key);
          if (element){
            element.vote = '('+value+')';
          }
        }
      }
    },
    setThumb(index) {
      //early reaturn
      if (this.disableInteraction){
        return;
      }
      if (this.labelVotes[index].vote === '(0)') {
        //set thumb up, if not voted yet
        this.labelVotes[index].vote = '(1)';
      } else if (this.labelVotes[index].vote === '(1)') {
        //set thumb down, if tumb up is set
        this.labelVotes[index].vote = '(-1)';
      } else {
        //set thumb up, if not thumb down or undefined option is set
        this.labelVotes[index].vote = '(1)';
      }
      this.setInput();    
    },
    setInput() {
      let input = [];
      let allVoted = true;
      for (let element of this.labelVotes) {
        if (element.vote === '(1)' || element.vote === '(-1)') {
          input.push(element.label + element.vote);
        } else {
          //if there is one not voted label, input is not emitted, to keep the voting button disabled
          input = [];
          allVoted = false;
          break;
        }
      }
      //console.log('input = ', input);
      if (allVoted) {
        let serverInput = this.getServerData(input, null, this.spot);
        this.$emit('input', input, serverInput);
      }
    },
  },
};
</script>

<style scoped lang="scss">
 .v-list {
   background-color: transparent;
 }
  img{
    width: 30px;
    height:30px;
  }
  .voting-thumb-p {
    display: flex;
    align-items: center;
    color: #000;
  }

</style>
